import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {ClientEvent, Tracker, TrackImpression} from '@udemy/event-tracking';
import {
    OnePaneLayoutContainer,
    OnePaneLayoutFullWidthSection,
} from '@udemy/react-layout-components';

import styles from './content-section.module.less';

interface PropsType {
    title: string;
    description?: string;
    actionButton?: ReactNode;
    content?: ReactNode;
    id?: string;
    pageType?: string;
}

class ContentImpressionEvent extends ClientEvent {
    uiRegion: string;
    constructor(uiRegion: string) {
        super('GenAiContentImpressionEvent');
        this.uiRegion = uiRegion;
    }
}
export const ContentSection = (props: PropsType) => {
    const clientEvent = 'gen-ai-content';
    const trackImpression = function () {
        if (props.pageType === 'gen-ai')
            Tracker.publishEvent(new ContentImpressionEvent(clientEvent));
    };
    return (
        <TrackImpression trackFunc={trackImpression} key={'gen-ai-content'}>
            <div>
                <OnePaneLayoutFullWidthSection id={props.id}>
                    <div className={classNames(styles['content-container'])}>
                        <OnePaneLayoutContainer>
                            <div className={classNames(styles['title-section'])}>
                                <h1 className={classNames('ud-heading-xxl')}>{props.title}</h1>
                                {props.description && (
                                    <div className={classNames('ud-text-large')}>
                                        {props.description}
                                    </div>
                                )}
                            </div>
                            {props.content}
                            {props.actionButton && (
                                <div className={classNames(styles['action-button'])}>
                                    {props.actionButton}
                                </div>
                            )}
                        </OnePaneLayoutContainer>
                    </div>
                </OnePaneLayoutFullWidthSection>
            </div>
        </TrackImpression>
    );
};
